import React from "react";
import { useTranslation } from "react-i18next";
import { ElementRoot } from "./ElementRoot.jsx";
import { mediaElementShape } from "./shapes/index.jsx";
import AngLoader from "../../component.ang_loader.jsx";

export const VideoPreviewMessage = ({ progress }) => {
  const { t } = useTranslation();

  const progressbarStyle = {
    width: `${progress}%`,
  };

  return (
    <ElementRoot loaded>
      <div className="ang_preview_message_wrapper">
        <div className="ang_preview_message_wrapper_inner">
          <div className="ang_preview_image ang_preview_image_video" />
          <div className="ang_preview_message">
            <p>{t("We&apos;re still preparing a preview for this video.")}</p>
            <p>{t("It&apos;ll play automatically as soon as it&apos;s ready.")}</p>
            {progress ? (
              <span className="ang_preview_progress_wrapper">
                <span className="ang_preview_progress">
                  <span style={progressbarStyle} />
                </span>
              </span>
            ) : (
              <AngLoader />
            )}
          </div>
        </div>
      </div>
    </ElementRoot>
  );
};

VideoPreviewMessage.propTypes = mediaElementShape;

VideoPreviewMessage.defaultProps = {
  progress: 0,
};
